import React from 'react';
import { ContentSections } from '../components/ContentSections';
import { FaqSection, GuaranteeSection } from '../components/FaqSection';
import { FinalSections } from '../components/FinalSections';
import { Hero } from '../components/Hero';
import { PricingSection } from '../components/PricingSection';
import { SocialProofToast } from '../components/SocialProofToast';
import { EarlySocialProof, ProStories } from '../components/TrustSections';
export function MegapackLanding() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-ink font-body text-ivory" data-id="element-166">
      <Hero data-id="element-167" />
      <EarlySocialProof data-id="element-168" />
      <ContentSections data-id="element-169" />
      <ProStories data-id="element-170" />
      <PricingSection data-id="element-171" />
      <GuaranteeSection data-id="element-172" />
      <FaqSection data-id="element-173" />
      <FinalSections data-id="element-174" />
      <SocialProofToast data-id="element-175" />
    </div>;
}